/* Overview (was DashboardHome) — lede + tiles + empty/loading states, in the shell's
 * language (13-15): the mock's page-head lede, its .notice for the honest empty state. */

/* The page-head lede (mock .pagehead p). */
.intro {
  margin: 8px 0 28px;
  max-width: 66ch;
  font-size: 15px;
  color: var(--gray);
}

.error {
  margin: 0 0 20px;
  max-width: 72ch;
  padding: 12px 16px;
  border-radius: 12px;
  background-color: var(--red-soft);
  color: var(--red-dark);
  font-size: 14px;
}

/* ── Loading ── */
.loading {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 12px;
  padding: 64px 0;
}

.loadingText {
  color: var(--gray);
  font-size: 14px;
}

/* ── Honest empty state (mock .notice) ── */
.empty {
  max-width: 640px;
  padding: 40px 32px;
  border: 1px solid var(--line);
  border-radius: 18px;
  background-color: var(--white);
}

.emptyTitle {
  margin: 0 0 6px;
  font-family: var(--serif);
  font-weight: 400;
  font-size: 26px;
  line-height: 1.2;
  color: var(--purple-dark);
}

.emptyBody {
  margin: 0;
  max-width: 60ch;
  font-size: 14.5px;
  color: var(--gray);
}
